import { useEffect, useRef } from "react";

const ScrollProgress = () => {
    const barRef = useRef(null);

    useEffect(() => {
        let raf = 0;
        const update = () => {
            const el = document.documentElement;
            const max = el.scrollHeight - el.clientHeight;
            const progress = max > 0 ? el.scrollTop / max : 0;
            if (barRef.current) barRef.current.style.transform = `scaleX(${progress})`;
        };
        const onScroll = () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(update);
        };
        update();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", onScroll);
            cancelAnimationFrame(raf);
        };
    }, []);

    return (
        <div aria-hidden="true" className="pointer-events-none fixed inset-x-0 top-0 z-50 h-[3px]">
            <div
                ref={barRef}
                className="h-full w-full origin-start bg-gradient-to-r from-gold-500 via-gold-600 to-pine"
                style={{ transform: "scaleX(0)" }}
                data-testid="scroll-progress-bar"
            />
        </div>
    );
};

export default ScrollProgress;
